import { z } from 'zod';

export interface CreateDocumentRequest {
  title: string;
  htmlContent: string;
}

export const CreateDocumentRequestSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  htmlContent: z.string().min(1, 'HTML content is required'),
});

